import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BufferService, LoadingContext, M_Button, M_ElementDrawer, M_Fieldset, M_FormFavorites, M_Header, M_InputTextField, M_MessageBoard, M_Table, NavigateContext } from 'src/M_Components'
import { ShipmentChargesShipmentTable } from './components/ShipmentChargesShipmentTable'
import { ShipmentChargesClass } from './components/ShipmentChargesClass'
import { ShipmentChargesDetails } from './components/ShipmentChargesDetails'
import { ShipmentChargesGroup } from './components/ShipmentChargesGroup'
import { ShipmentChargesRemarks } from './components/ShipmentChargesRemarks'
import { ShipmentChargesNature } from './components/ShipmentChargesNature'
import { ShipmentChargesSupplierDetails } from './components/ShipmentChargesSupplierDetails'
import { ShipmentChargesValues } from './components/ShipmentChargesValues'

export const ShipmentChargesDetail = ({ roles }) => {
    const ctx = useContext(LoadingContext)
    const navigateCtx = useContext(NavigateContext)
    const { t } = useTranslation()

    const shipmentChargesService = new BufferService('ShipmentCharges')
    const viewbookingService = new BufferService('viewbooking')

    const [data, setData] = useState({})
    const [operation, setOperation] = useState('')
    const [tabId, setTabId] = useState(sessionStorage.getItem('selectedTab'))
    const [sourceTabUrl, setSourceTabUrl] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [showPageCloseModal, setShowPageCloseModal] = useState(false)

    const [bookingDrawerOpen, setBookingDrawerOpen] = useState(false)
    const [shipmentDrawerOpen, setShipmentDrawerOpen] = useState(false)

    const [shipmentObjArray, setShipmentObjArray] = useState([])
    const [selectedShipments, setSelectedShipments] = useState([])

    const autoOpenedRef = useRef(false)
    const sessionKeys = ['operation', 'data']

    useEffect(() => {
        const passOperation = ctx.passValue.get('operation')
        setOperation(passOperation)

        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(tabId)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${tabId}`, JSON.stringify(sessionKeys))
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== tabId) {
            setTabId(newId)
            getSessionStorageData(newId)
        }
    }, [])

    useEffect(() => {
        sessionKeys.forEach((key) => sessionStorageMachine(tabId, key, key))
        // eslint-disable-next-line
    }, [tabId, data, operation])

    useEffect(() => {
        if (operation === 'create' && !autoOpenedRef.current && !data.BookingId) {
            autoOpenedRef.current = true
            setBookingDrawerOpen(true)
        }
    }, [operation])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        // eslint-disable-next-line
        sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0)) {
            setOperation(String(tempO))
            setData({ ...tempD })
            ctx.setIsLoad(false)
            return
        }
        get()
    }

    const get = () => {
        const passOperation = ctx.passValue.get('operation')
        const passSourceUrl = ctx.passValue.get('sourceTabUrl')
        if (passSourceUrl) {
            setSourceTabUrl(passSourceUrl)
            sessionStorage.setItem(`${tabId}sourceTabUrl`, passSourceUrl)
        } else {
            const stored = sessionStorage.getItem(`${tabId}sourceTabUrl`)
            if (stored) setSourceTabUrl(stored)
        }

        if (passOperation === 'create') {
            const prefill = ctx.passValue.get('Row')
            if (prefill?.BookingId) {
                setData(prev => ({ ...prev, BookingId: prefill.BookingId, BookingNumber: prefill.BookingNumber }))
                if (prefill.ShipmentId) {
                    setSelectedShipments([prefill.ShipmentId])
                }
            }
            ctx.setIsLoad(false)
            return
        }

        const row = ctx.passValue.get('Row')
        if (!row) { ctx.setIsLoad(false); return }

        shipmentChargesService.getId(row.Id).then((response) => {
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', response?.response?.data?.Errors || response.message)
                ctx.setIsLoad(false)
                return
            }
            if (passOperation === 'copy') {
                const { Id, DbStatus, ...copyData } = response
                setData({ ...copyData, IsFromQuote: false })
            } else {
                setData(response)
            }
            ctx.setIsLoad(false)
        }).catch((err) => {
            ctx.toastMessages('error', '', err.message)
            ctx.setIsLoad(false)
        })
    }

    const onBookingPassLine = async (lines) => {
        const booking = lines?.[0]
        if (!booking) return
        setData(prev => ({ ...prev, BookingId: booking.Id, BookingNumber: booking.BookingNumber }))
        setSelectedShipments([])
        setBookingDrawerOpen(false)

        ctx.setIsLoad(true)
        try {
            const bookingData = await viewbookingService.getId(booking.Id)
            const tempObjArray = []
            let mainIndex = 0

            let equipmentIndex = 0
            ;(bookingData?.ShipmentPlusList || []).forEach((shipments) => {
                const details = shipments.ShipmentDetailPlusList || []
                if (details.length === 0) return

                details.forEach((detail) => {
                    mainIndex++
                    equipmentIndex++
                    const eqCode = detail.EquipmentType?.EquipmentTypeCode || ''
                    tempObjArray.push({
                        'id': mainIndex,
                        'ShipmentId': shipments.Shipment?.Id,
                        'Shipment': shipments.Shipment?.TransportKey,
                        'EquipmentIndex': equipmentIndex,
                        'EquipmentTransportKey': detail.ShipmentDetail?.Order || '',
                        'Equipment Type': `${detail.EquipmentType?.EquipmentTypeLenght || ''}${eqCode}`,
                        'Cargo Description': detail.BookingEquipment?.GoodsDetails || '',
                        'Load Weight (KG)': detail.BookingEquipment?.TransportDetails || '',
                        'Loading Date': detail.BookingEquipment?.LoadingDate?.slice(0, 10) || '',
                        'SOC': detail.BookingEquipment?.SOC === 'Y',
                        'IMO': shipments.Shipment?.IMODangerGoods || false,
                        'Reefer': eqCode.includes('RF') || eqCode.includes('HR'),
                        'RORO': eqCode.includes('RORO'),
                        'OpenTop': eqCode.includes('OT') || eqCode.includes('FL'),
                        'Prefix': detail.Equipment?.Prefix || '',
                        'Number': detail.Equipment?.Number || '',
                        'CheckDigit': detail.Equipment?.CheckDigit || '',
                        'shipmentChanged': [],
                        'dangerousGoods': [],
                    })
                })
            })

            setShipmentObjArray(tempObjArray)
        } catch {
            setShipmentObjArray([])
        }
        ctx.setIsLoad(false)
        setShipmentDrawerOpen(true)
    }

    const confirmShipments = () => {
        setShipmentDrawerOpen(false)
    }

    const onSave = async () => {
        if (!data.ServiceTypeId) {
            ctx.toastMessages('error', '', `${t('ServiceCode')} ${t('FieldIsRequired')}`)
            return
        }

        if (operation === 'create') {
            if (!data.BookingId) {
                ctx.toastMessages('error', '', `${t('BookingNumber')} ${t('FieldIsRequired')}`)
                return
            }
            if (selectedShipments.length === 0) {
                ctx.toastMessages('error', '', `${t('Shipment')} ${t('FieldIsRequired')}`)
                return
            }

            ctx.setIsLoad(true)
            const basePayload = { ...data, IsFromQuote: false }

            const results = await Promise.all(
                selectedShipments.map((shipmentId) =>
                    shipmentChargesService.post({ ...basePayload, ShipmentId: shipmentId })
                )
            )

            const errorResult = results.find((r) => r.name === 'AxiosError')
            if (errorResult) {
                const resData = errorResult?.response?.data
                ctx.toastMessages('error', '', resData !== null && resData !== undefined ? Object.values(resData).flat().join('\n') || errorResult.message : '')
                ctx.setIsLoad(false)
            } else {
                ctx.toastMessages('success', '', t('CreatedShipmentCharge'))
                ctx.setIsLoad(false)
                sessionStorage.setItem('chargesNeedRefresh', '1')
                navigateCtx.closeTab(tabId.replace(/"/g, ''), sourceTabUrl || undefined)
            }
        } else if (operation === 'copy') {
            if (!data.ShipmentId) {
                ctx.toastMessages('error', '', `${t('Shipment')} ${t('FieldIsRequired')}`)
                return
            }
            ctx.setIsLoad(true)
            const payload = { ...data, IsFromQuote: false }
            shipmentChargesService.post(payload).then((response) => {
                if (response.name === 'AxiosError') {
                    const resData = response?.response?.data
                    ctx.toastMessages('error', '', resData !== null && resData !== undefined ? Object.values(resData).flat().join('\n') || response.message : '')
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('success', '', t('CreatedShipmentCharge'))
                    ctx.setIsLoad(false)
                    sessionStorage.setItem('chargesNeedRefresh', '1')
                    navigateCtx.closeTab(tabId.replace(/"/g, ''), sourceTabUrl || undefined)
                }
            })
        } else if (operation === 'edit') {
            ctx.setIsLoad(true)
            const payload = { ...data, IsFromQuote: false }
            shipmentChargesService.update(data.Id, payload).then((response) => {
                if (response.name === 'AxiosError') {
                    const resData = response?.response?.data
                    ctx.toastMessages('error', '', resData !== null && resData !== undefined ? Object.values(resData).flat().join('\n') || response.message : '')
                    ctx.setIsLoad(false)
                } else {
                    ctx.toastMessages('success', '', t('EditedShipmentCharge'))
                    ctx.setIsLoad(false)
                    sessionStorage.setItem('chargesNeedRefresh', '1')
                    navigateCtx.closeTab(tabId.replace(/"/g, ''), sourceTabUrl || undefined)
                }
            })
        }
    }


    const varNameDict = useMemo(() => new Map([
        ['ServiceTypeCode',   data?.ServiceTypeCode   || ''],
        ['PayingLocationCode', data?.PayingLocationCode || ''],
        ['InvoiceCompanyCode', data?.InvoiceCompanyCode || ''],
        ['LumpSumCode',       data?.LumpSumCode       || ''],
        ['CurrencyCode',      data?.CurrencyCode      || ''],
        ['LineCurrencyCode',  data?.LineCurrencyCode  || ''],
        ['SupplierCode',      data?.SupplierCode      || ''],
        ['CostCurrencyCode',  data?.CostCurrencyCode  || ''],
    ]), [data?.ServiceTypeCode, data?.PayingLocationCode, data?.InvoiceCompanyCode, data?.LumpSumCode, data?.CurrencyCode, data?.LineCurrencyCode, data?.SupplierCode, data?.CostCurrencyCode])

    // abaixo de 700px tudo empilha numa coluna
    const [isNarrow, setIsNarrow] = useState(() => window.innerWidth < 700)
    useEffect(() => {
        const handleResize = () => setIsNarrow(window.innerWidth < 700)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <M_FormFavorites
            entityName="ShipmentCharges"
            pageUrl="ShipmentCharges"
            varNameDict={varNameDict}
            setVarNameDict={() => {}}
            onFavoriteLoad={(loadedData) => setData(prev => ({ ...prev, ...loadedData }))}
            onAfterApply={() => {}}
        >
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t('Back')}
                            label={t('Back')}
                            icon={<i className='pi pi-arrow-left iconTable' style={{ width: '20px', color: ctx.secondaryColor || 'var(--color-black)' }}></i>}
                            onClick={() => setShowPageCloseModal(true)}
                        />
                        <M_Button
                            tooltip={t('Save')}
                            icon={<i className='pi pi-save iconTable'></i>}
                            label={t('Save')}
                            onClick={onSave}
                        />
                    </>
                }
            />

            {/* Shipment section */}
            <div style={{ margin: '10px 20px' }}>
                <M_Fieldset
                    labelInside
                    label={
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                            <i className='pi pi-box' style={{ fontSize: '18px' }} />
                            {t('Shipment')}
                        </div>
                    }
                    elements={
                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', padding: '10px 16px' }}>

                            <div
                                onClick={operation === 'create' ? () => setBookingDrawerOpen(true) : undefined}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '10px',
                                    padding: '8px 14px', borderRadius: '8px',
                                    border: '1px solid var(--color-blue)',
                                    cursor: operation === 'create' ? 'pointer' : 'default',
                                    backgroundColor: 'var(--color-white)',
                                    transition: 'background 0.15s',
                                }}
                                onMouseEnter={e => { if (operation === 'create') e.currentTarget.style.backgroundColor = 'rgba(0,120,200,0.05)' }}
                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'var(--color-white)' }}
                            >
                                <i className='pi pi-book' style={{ fontSize: '16px', color: 'var(--color-blue)' }} />
                                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
                                    <span style={{ fontSize: '11px', color: 'var(--color-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        {t('BookingNumber')}
                                    </span>
                                    <span style={{ fontSize: '15px', fontWeight: 700, color: data.BookingNumber ? 'var(--color-blue)' : 'var(--color-gray)' }}>
                                        {data.BookingNumber || '—'}
                                        {operation === 'create' && <i className='pi pi-search' style={{ fontSize: '11px', marginLeft: '6px', opacity: 0.6 }} />}
                                    </span>
                                </div>
                            </div>

                            <i className='pi pi-angle-right' style={{ fontSize: '16px', color: 'var(--color-gray)', opacity: 0.5 }} />

                            <div
                                onClick={operation === 'create' && data.BookingId ? () => setShipmentDrawerOpen(true) : undefined}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '10px',
                                    padding: '8px 14px', borderRadius: '8px',
                                    border: `1px solid ${operation === 'create' && data.BookingId ? 'var(--color-blue)' : 'var(--color-lightgray)'}`,
                                    cursor: operation === 'create' && data.BookingId ? 'pointer' : 'default',
                                    backgroundColor: 'var(--color-white)',
                                    opacity: operation === 'create' && !data.BookingId ? 0.45 : 1,
                                    transition: 'background 0.15s',
                                }}
                                onMouseEnter={e => { if (operation === 'create' && data.BookingId) e.currentTarget.style.backgroundColor = 'rgba(0,120,200,0.05)' }}
                                onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'var(--color-white)' }}
                            >
                                <i className='pi pi-truck' style={{ fontSize: '16px', color: 'var(--color-blue)' }} />
                                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
                                    <span style={{ fontSize: '11px', color: 'var(--color-gray)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        {t('Shipment')}
                                    </span>
                                    <span style={{ fontSize: '15px', fontWeight: 700, textTransform: 'none', color: (operation === 'edit' ) ? 'var(--color-blue)' : selectedShipments.length > 0 ? 'var(--color-green)' : 'var(--color-gray)' }}>
                                        {(operation === 'edit')
                                            ? (data.ShipmentTransportKey != null ? `Shipment ${data.ShipmentTransportKey}` : '—')
                                            : selectedShipments.length > 0
                                                ? `${selectedShipments.length} ${selectedShipments.length === 1 ? t('Shipment') : t('Shipments')}`
                                                : '—'
                                        }
                                        {operation === 'create' && data.BookingId && <i className='pi pi-search' style={{ fontSize: '11px', marginLeft: '6px', opacity: 0.6 }} />}
                                    </span>
                                </div>
                            </div>

                        </div>
                    }
                />
            </div>

            <div style={{ margin: '0 20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>

                {/* Row 1: Details */}
                <ShipmentChargesDetails dataState={data} setDataState={setData} />

                {/* Row 2: Groups — lego */}
                <div style={{ display: 'flex', flexDirection: isNarrow ? 'column' : 'row', gap: '10px', alignItems: 'stretch' }}>

                    {/* Col esquerda: Group + Values + Remarks */}
                    <div style={{ flex: '3 1 0px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <ShipmentChargesGroup dataState={data} setDataState={setData} />
                        <ShipmentChargesValues dataState={data} setDataState={setData} />
                        <ShipmentChargesRemarks dataState={data} setDataState={setData} />
                    </div>

                    {/* Col direita: Class + Nature + SupplierDetails */}
                    <div style={{ flex: '2 1 0px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <ShipmentChargesClass dataState={data} setDataState={setData} />
                        <ShipmentChargesNature dataState={data} setDataState={setData} />
                        <ShipmentChargesSupplierDetails dataState={data} setDataState={setData} style={{ flex: 1, boxSizing: 'border-box' }} />
                    </div>
                </div>

            </div>

            {/* Booking lateral drawer */}
            <M_ElementDrawer
                open={bookingDrawerOpen}
                setOpen={setBookingDrawerOpen}
                onClose={() => setBookingDrawerOpen(false)}
                element={
                    <>
                        <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{t('BookingNumber')}</h2>
                        <M_Table
                            entityName={'booking'}
                            useSessionStorage={false}
                            crud={false}
                            selectSingle={true}
                            onPassLine={onBookingPassLine}
                        />
                    </>
                }
            />

            {/* Shipment lateral drawer — groups equipment rows by shipment, one checkbox per shipment */}
            {data.BookingId && (
                <M_ElementDrawer
                    open={shipmentDrawerOpen}
                    setOpen={setShipmentDrawerOpen}
                    onClose={() => setShipmentDrawerOpen(false)}
                    element={
                        <>
                            <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{t('Shipment')}</h2>
                            <ShipmentChargesShipmentTable
                                value={shipmentObjArray}
                                selectedShipments={selectedShipments}
                                setSelectedShipments={setSelectedShipments}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                                <M_Button
                                    normal
                                    hoverEffect
                                    label={`${t('Confirm') || 'Confirm'} (${selectedShipments.length})`}
                                    icon={<i className='pi pi-check' style={{ fontSize: '13px', marginRight: '4px' }} />}
                                    labelColor='white'
                                    backgroundColor='var(--color-green)'
                                    onClick={confirmShipments}
                                />
                            </div>
                        </>
                    }
                />
            )}


            <M_MessageBoard
                warning
                open={showPageCloseModal}
                onClose={() => setShowPageCloseModal(false)}
                title={t('leavingPageTitle')}
                body={t('leavingPageBody')}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setShowPageCloseModal(false)} label={t('ButtonCancel')} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => navigateCtx.closeTab(JSON.parse(tabId), sourceTabUrl || undefined)} label={t('ButtonConfirm')} />
                    </span>
                }
            />
        </div>
        </M_FormFavorites>
    )
}
